export default __webpack_public_path__ + "static/media/status_archived.fb3c7d1d.svg";